import type { ReportListStatus } from '@/models/report';
import type { BadgeVariant } from './StatusBadge';

export const STATUS_CONFIG: Record<
  ReportListStatus,
  { variant: BadgeVariant; label: string }
> = {
  FINAL: { variant: 'success', label: 'Final' },
  DRAFT: { variant: 'warning', label: 'Draft' },
  ADDENDUM: { variant: 'info', label: 'Addendum' },
  PRELIMINARY: { variant: 'info', label: 'Preliminary' },
};

export const STATUS_PRIORITY: ReportListStatus[] = [
  'ADDENDUM',
  'FINAL',
  'PRELIMINARY',
  'DRAFT',
];
